module.exports = __webpack_public_path__ + "img/restauParis.8fb97406.jpeg";